// register split text
gsap.registerPlugin(ScrollTrigger, SplitText);

var searchProducts = [];
var searchCollections = [];
var searchArticles = [];

var sProdBlock = `
	<a href='%URL%' class='product'>

            <div class='image'>
			  <img src='%IMAGE%' alt='%TITLE%' />
            </div>

            <div class='infos'>

              <p class='name'>
                %TITLE%
              </p>

              <p class='price'>
                %PRICE%
              </p>

            </div>

          </a>
	`;

var sCollblock = `
	<a href='%URL%' class='collection hover-underline-white'>
		%TITLE%
	</a>`;

var sBlogblock = `
	<a href='%URL%' class='blog'>

            <div class='image'>
			  <img src='%IMAGE%' alt='%TITLE%' />
            </div>

            <div class='infos'>

              <p class='title'>
                %TITLE%
              </p>

              <p class='desc'>
                %EXCERPT%
              </p>

            </div>

          </a>
		  `;

var productSuggestions;
var collectionSuggestions;
var blogSuggestions;
var sort = "title";
var order = "dsc";

function predictiveSearch(searchText) {
	$('#collection-search').empty();
	$('#prod_search').empty();
	$('#blog-search').empty();
	$.getJSON("/search/suggest.json", {
		"q": searchText,
		"resources": {
			"type": "product,article,collection",
			"limit": 5,
			"options": {
				"unavailable_products": "last",
				"fields": "title,product_type,variants.title"
			}
		}
	}).done(function (response) {
		productSuggestions = response.resources.results.products;

		var prodH = "";
		for (suggestion in productSuggestions) {
			var prodR = sProdBlock;
			var cost = productSuggestions[suggestion].price.substring(0, productSuggestions[suggestion].price.length - 2) + productSuggestions[suggestion].price.substring(productSuggestions[suggestion].price.length - 2);
			var cost2 = '$' + cost;
			prodR = prodR.replace("%URL%", productSuggestions[suggestion].url).replace("%PRICE%", cost2).replace("%IMAGE%", productSuggestions[suggestion].image);
			prodR = replaceAll(prodR, "%TITLE%", productSuggestions[suggestion].title);
			prodH += prodR;
		}

		if (productSuggestions.length == 0) {
			var text = "<p>No Results Found.</p>";
			prodH += text;
		}

		collectionSuggestions = response.resources.results.collections;

		var collH = "";
		console.log("Collection Suggestions: " + JSON.stringify(collectionSuggestions));
		for (collection in collectionSuggestions) {
			console.log("Iterating: " + JSON.stringify(collectionSuggestions[collection]));
			var collR = sCollblock;
			collR = collR.replace("%URL%", collectionSuggestions[collection].url);
			collR = replaceAll(collR, "%TITLE%", collectionSuggestions[collection].title);
			collH += collR;
		}

		if (collectionSuggestions.length == 0) {
			var text = "<p>No Results Found.</p>";
			collH += text;
		}

		blogSuggestions = response.resources.results.articles;

		var blogH = "";
		console.log("blog Suggestions: " + JSON.stringify(blogSuggestions));
		for (blog in blogSuggestions) {
			console.log("Iterating: " + JSON.stringify(blogSuggestions[blog]));
			var blogR = sBlogblock;
			blogR = blogR.replace("%URL%", blogSuggestions[blog].url).replace("%IMAGE%", blogSuggestions[blog].image).replace("%EXCERPT%", blogSuggestions[blog].summary_html);
			blogR = replaceAll(blogR, "%TITLE%", blogSuggestions[blog].title);
			blogH += blogR;
		}

		if (blogSuggestions.length == 0) {
			var text = "<p>No Results Found.</p>";
			blogH += text;
		}

		$('#prod_search').prepend($.parseHTML(prodH));

		$('#collection-search').prepend($.parseHTML(collH));

		$('#blog-search').prepend($.parseHTML(blogH));

	});
}

var changes = 0;

$(document).ready(function () {
	$("#searchBar").keypress(function () {
		changes += 1;
		if (changes != 2) {
			console.log("Changes: " + changes);
		} else {
			predictiveSearch($("#searchBar").val());
			changes = 0;
		}
	});

	$('#sort').on('change', function () {
		sort = this.value;
	});

	$('order').on('change', function () {
		order = this.value;
	});
});



// init all click, mouseover and keyup functions
function initClickAndKeyFunctions() {

	// make anchor links scroll smoothy
	$('.sliding-link').click(function (e) {
		e.preventDefault()
		var aid = $(this).attr('href')
		$('html, body').animate({ scrollTop: $(aid).offset().top }, 'slow')
	})

	// correct label click
	$('label').click(function (e) {
		e.stopImmediatePropagation()
	})

	// open / close fs menu
	$('.open-fs').click(function () {
		$(this).toggleClass('opened')
		$('body').toggleClass('fs-menu-open')
	})

	$('#fs-menu a, #top-menu a').click(function () {
		$('.open-fs').removeClass('opened')
		$('body').removeClass('fs-menu-open')
	})

	// open / close cart menu
	$('.open-cart').click(function () {
		openCart();
	})

	$('#cart-menu .bg, #cart-menu .close-cart').click(function () {
		closeCart();
	})

	// open / close search menu
	$('.open-search').click(function () {
		$('body').toggleClass('search-menu-open')
		setTimeout(function () {
			$('#search-menu .search').focus();
		}, 100)
	})

	$('#search-menu .bg, #search-menu .close-search').click(function () {
		$('body').removeClass('search-menu-open')
	})

	// change search filters inside the search menu
	$('#search-menu .filters button').click(function () {
		var that = $(this);

		$('#search-menu .filters button').removeClass('active');
		$('#search-menu .results > div').slideUp();

		setTimeout(function () {
			that.addClass('active')
		})

		if (that.hasClass('products')) {
			setTimeout(function () {
				$('#search-menu .results .products').slideDown();
			}, 50)
		}

		if (that.hasClass('collections')) {
			setTimeout(function () {
				$('#search-menu .results .collections').slideDown();
			}, 50)
		}

		if (that.hasClass('blogs')) {
			setTimeout(function () {
				$('#search-menu .results .blogs').slideDown();
			}, 50)
		}

	})

	// close all opened menus when pressing the ESC key
	$(document).keyup(function (e) {
		if (e.key === 'Escape') {
			$('body').removeClass('fs-menu-open cart-menu-open search-menu-open')
			$('.open-fs').removeClass('opened')
			$('#filters').removeClass('open')
			setTimeout(function () {
				$('body').removeClass('filters-open')
			}, 300)
		}
	})

	// sub menu
	$('#fs-menu .has-sub').click(function () {
		$(this).toggleClass('active')
		$(this).children('.sub').slideToggle()
	})

	// refine search
	$('.open-filters').click(function () {
		$('#filters').addClass('open')
		$('body').addClass('filters-open')
	})

	$('#filters .close-filters, #filters .bg, #filters .hollow-black-button').click(function () {
		$('#filters').removeClass('open')
		setTimeout(function () {
			$('body').removeClass('filters-open')
		}, 300)
	})

	// faq open / close
	$('.faq-question .title').click(function () {
		$(this).parent('.faq-question').toggleClass('active')
		$(this).siblings('.desc').slideToggle()
		setTimeout(function () {
			ScrollTrigger.refresh()
		}, 450)
	})

	// open products sub-menu
	$('#top-menu .menu .has-sub, #products-menu').off();

	$('#top-menu .menu .has-sub, #products-menu').mouseout(function () {
		window.megamenu = false;
		setTimeout(function () {
			if (!window.megamenu) $('#top-menu, #products-menu').removeClass('active');
		}, 600);
	})

	$('#top-menu .menu .has-sub, #products-menu').mousemove(function () {
		window.megamenu = true;
		$('#top-menu, #products-menu').addClass('active');
	});

	// show / hide password
	$('.show-hide-pass').click(function () {
		var that = $(this);
		that.toggleClass('active');

		setTimeout(function () {
			if (that.hasClass('active')) {
				that.siblings('input').attr('type', 'text');
			} else {
				that.siblings('input').attr('type', 'password');
			}
		}, 30)
	})

	// show / hide frequency when clicking on subs and save on the product inner page
	$('#subs-and-save').click(function () {
		$('#frequency').slideDown();
	})

	$('#one-time').click(function () {
		$('#frequency').slideUp();
	})

	// close cookies popup
	$('#cookies-popup button').click(function () {
		console.log("Accepted");
		setCookie("cookies", "true", 999);
		$('#cookies-popup').fadeOut()
	})

	// free shipping looping
	if (document.querySelector(".free-shipping")) {
		gsap.to('.free-shipping .marquee', {
			x: '-11.25rem',
			duration: 5,
			ease: 'linear',
			repeat: -1
		})
	}

	// init pencil banner
	if (document.querySelector('.pencil-banner')) {
		const pencil_slider = new Swiper('.pencil-slider', {
			slidesPerView: 1,
			loop: true,
			simulateTouch: false,
			allowTouchMove: false,
			autoHeight: false,
			calculateHeight: false,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			autoplay: {
				delay: 5000
			}
		})
	}
}

function openCart() {
	const cartItemHolder = $("#products");
	cartItemHolder.empty();
	$("#loading").css("display", "block");
	$('body').toggleClass('cart-menu-open');
	setTimeout(() => {
		fetchCart();
	}, 1000);
}

function closeCart() {
	$('body').removeClass('cart-menu-open');
}

function fetchCart() {
	$.ajax({
		type: 'GET',
		url: '/cart.js',
		dataType: 'json',
		success: function (cart) {
			renderCart(cart);
		},
	});
}

const cartItem =
	`<div class='product'>

        <div class='left'>

          <a href='product-inner' class='image'>
            <img src="%PRODUCT_IMAGE%" alt="%PRODUCT_TITLE%" />
          </a>

          <div class='infos'>

            <p class='name'>
              %PRODUCT_TITLE%
            </p>

            <p class='price'>
              %PRODUCT_PRICE%
            </p>

			<p class='plan'>
              %PRODUCT_PLAN%
            </p>

          </div>

        </div>

        <div class='right'>

          <input
            type='number'
            min='1'
            max='999'
			value='%QUANTITY%'
            placeholder='0'
            id='quantity'
            onfocusout="changeItem(%PRODUCT_ID%, this.value)">

          <button onClick="changeItem(%PRODUCT_ID%, 0)" class='remove hover-underline-white simon'>
            Remove
          </button>

        </div>

      </div>`;

function changeItem(line, quantity) {
	$.ajax({
		type: 'POST',
		url: '/cart/change.js',
		data: 'quantity=' + quantity + '&id=' + line,
		dataType: 'json',
		success: function (cart) {
			renderCart(cart);
		}
	});
}



function renderCart(cart) {

	const cartItemHolder = $("#products");

	cartItemHolder.empty();

	console.log("Cart: " + JSON.stringify(cart));


	if (cart.items.length != 0) {
		$("#empty").css("display", "hidden");
		cartItemHolder.removeClass("hidden");
		$('#protection').css("display", "block");
	} else {
		$("#empty").css("display", "block");
		cartItemHolder.addClass("hidden");
		$('#protection').css("display", "none");
	}

	var cartCount = $(".cart-items .text-small");

	cartCount.text(cart.item_count);

	var subtotal = cart.items_subtotal_price;
	subtotal = (subtotal / 100).toLocaleString("en-US", { style: "currency", currency: "USD" });



	cart.items.forEach(function (item, index) {

		console.log("Selling Plan" + (item.hasOwnProperty("selling_plan_allocation") ? item.selling_plan_allocation.selling_plan.name : "Didnt have plan"));
        //console.log('plan', item);


		var cost = item.price;

		cost = (cost / 100).toLocaleString("en-US", { style: "currency", currency: "USD" });

		var cartItem2 = replaceAll(cartItem, "%PRODUCT_TITLE%", item.title);
		cartItem2 = replaceAll(cartItem2, "%QUANTITY%", item.quantity);
		cartItem2 = replaceAll(cartItem2, "%ID%", item.id);
		cartItem2 = replaceAll(cartItem2, "%PRODUCT_IMAGE%", (item.image).replace(".png", "_500x500.png").replace(".jpg", "_500x500.jpg"));

		cartItem2 = replaceAll(cartItem2, "%PRODUCT_PRICE%", cost);

		cartItem2 = replaceAll(cartItem2, "%PRODUCT_PLAN%", item.hasOwnProperty("selling_plan_allocation") ? item.selling_plan_allocation.selling_plan.name : "");

		cartItem2 = replaceAll(cartItem2, "%PRODUCT_ID%", item.id);
		cartItem2 = replaceAll(cartItem2, "%HANDLE%", item.handle);

		cartItemHolder.prepend(cartItem2);

	});

	$("#subtotal").text(subtotal);

	$("#cartCount").text(cart.items.length);

	$("#loading").css("display", "none");

}

function replaceAll(str, find, replace) {
	return str.replace(new RegExp(find, 'g'), replace);
}


$('.shopify-product-form').submit(function () {
  console.log('post cart', $(this).serialize());
	$.ajax({
		type: 'POST',
		url: '/cart/add',
		data: $(this).serialize(),
		success: openCart()
	});
	return false;
});

var last_id = 'dashboardd';

function switchMenu(id) {
	$('.dashboard-menu .active').removeClass('active');
	$('.dashboard-menu a.' + id).addClass('active');
	$('#' + id).css("display", "block");
	$('#' + last_id).css("display", "none");
	last_id = id;
}

// add the active class to the dashboard menu
function initDashboardMenu() {
	$('.dashboard-menu a.dashboard').addClass('active')

}

// init lazyload
function initLazyLoad() {
	const lazyLoadInstance = new LazyLoad({
		elements_selector: '.lazy',
	});

	gsap.utils.toArray('.lazy').forEach(item => item.addEventListener('load', () => ScrollTrigger.refresh()));
}

// init fancybox
function initFancybox() {
	Fancybox.bind('[data-fancybox]', {
		autoFocus: false,
		dragToClose: false,
		placeFocusBack: false,
	})
}

// validate footer newsletter
function validateForms() {
	if (document.querySelector(".form-validate")) {

		const form = $('.form-validate')

		$.each(form, function () {
			$(this).validate({
				errorPlacement: function (error, element) {
					error.appendTo(element.closest('.form-line'))
					error.addClass('error-msg')
				},
				highlight: function (element) {
					$(element).closest('.form-line').addClass('error')
				},
				unhighlight: function (element) {
					$(element).closest('.form-line').removeClass('error')
				}
			})
		})
	}
}

// scroll related animations
function scrollTriggerAnimations() {

	// title fill animation
	if (document.querySelector(".fill-title")) {

		const split = new SplitText('.fill-title', { type: 'lines' })

		split.lines.forEach((target) => {
			gsap.to(target, {
				backgroundPositionX: 0,
				ease: 'none',
				scrollTrigger: {
					trigger: target,
					scrub: 2,
					start: 'top 75%',
					end: 'bottom 75%',
				}
			})
		})
	}

	// typewriter animation effect
	if (document.querySelector(".typewriter")) {

		const typewriter = $('.typewriter')

		$.each(typewriter, function () {

			let el = $(this).children('.text');
			let text = $.trim($(this).children('.text').text());
			let letters = $.trim($(this).children('.text').text()).length;
			let cursor = $(this).children('.cursor');

			let timeline = gsap.timeline({
				//paused: true,
				yoyo: true,
				repeat: -1,
				repeatDelay: 2
			})

			timeline.fromTo(el, {
				text: {
					value: ''
				}
			}, {
				text: {
					value: text
				},
				duration: 2,
				ease: SteppedEase.config(letters),
				yoyo: true
			})

			let cursorTimeline = gsap.timeline({
				//paused: true,
				yoyo: true,
				repeat: -1,
			});

			cursorTimeline.to(cursor, {
				autoAlpha: 0,
				duration: 1,
				ease: SteppedEase.config(1)
			});

			// play and pause the typewriter animation when in / out of view
			/*
			ScrollTrigger.create({
				trigger: typewriter,
				start: '0% 120%',
				end: '100% -20%',
				markers: true,
				onEnter: () => timeline.play() && cursorTimeline.play(),
				onEnterBack: () => timeline.play() && cursorTimeline.play(),
				onLeave: () => timeline.pause() && cursorTimeline.pause(),
				onLeaveBack: () => timeline.pause() && cursorTimeline.pause(),
			});
			*/
		})
	}

	// image reveal animation
	if($(".image-reveal")) {

		const imageReveal = $('.image-reveal')
	
		imageReveal.each(function () {
			const reveal = $(this).children('.reveal')
			const image = $(this).children('img')
	
			const timeline = gsap.timeline({
				paused: true
			})
	
			timeline.set(image, {
				scale: 1.5
			})
	
			timeline.to(reveal, {
				width: '100%',
				ease: Power4.easeInOut,
				duration: 0.75
			})
	
			timeline.to(reveal, {
				x: '100%',
				ease: Power4.easeIn,
				duration: 1.0
			})
	
			timeline.to(image, {
				visibility: 'visible',
				scale: 1,
				duration: 2.5,
				ease: Power4.easeOut
			}, '=-1')
	
			ScrollTrigger.create({
				trigger: this,
				start: '0% 100%',
				end: '100% 0%',
				onEnter: () => timeline.play(),
				onLeaveBack: () => timeline.reverse()
			})
		})
	}

}

// replicate similar effects to 'wow'
function staggerChildren() {
	if (document.querySelector('.stagger-children')) {

		gsap.set('.stagger-children > *', {
			autoAlpha: 0,
			y: '3rem',
		})

		ScrollTrigger.batch('.stagger-children > *', {
			start: '0 95%',
			onEnter: elements => {
				gsap.to(elements, {
					autoAlpha: 1,
					y: '=-3rem',
					stagger: 0.15,
					duration: 1
				});
			},
			onLeaveBack: elements => {
				gsap.to(elements, {
					autoAlpha: 0,
					y: '3rem',
					stagger: 0.15,
					duration: 1,
				})
			}
		})
	}

	if (document.querySelector('.stagger-logos')) {

		ScrollTrigger.batch('.stagger-logos > *', {
			start: 'top 80%',
			onEnter: elements => {
				gsap.to(elements, {
					opacity: 1,
					stagger: 0.15,
					duration: 1
				})
			},
			onLeaveBack: elements => {
				gsap.to(elements, {
					opacity: .05,
					stagger: 0.15,
					duration: 1
				})
			}
		})
	}
}

// init all sliders
function initSliders() {

	if (document.querySelector('.products-slider')) {
		if (window.innerWidth > 768) {
			const products_slider = new Swiper('.products-slider', {
				slidesPerView: 2,
				loop: true,
				simulateTouch: true,
				allowTouchMove: true,
				autoHeight: false,
				calculateHeight: false,
				spaceBetween: 20,
				navigation: {
					nextEl: '.products-slider-wrapper .arrow.next',
					prevEl: '.products-slider-wrapper .arrow.prev',
				},
				breakpoints: {
					1201: {
						slidesPerView: 3,
						spaceBetween: 20,
						loop: true,
					}
				},

				// fix the loop for when you have lazyloaded images inside it
				// https://github.com/verlok/vanilla-lazyload/blob/master/demos/swiper.html
				on: {
					afterInit: (swiper) => {
						new LazyLoad({
							container: swiper.el,
							cancel_on_exit: false
						});
					}
				}
			});

			setTimeout(function () {
				products_slider.update()
			}, 10);
		}
	}

	if (document.querySelector('.reviews-slider')) {
		const reviews_slider = new Swiper('.reviews-slider', {
			slidesPerView: 1,
			loop: false,
			simulateTouch: true,
			allowTouchMove: true,
			autoHeight: false,
			calculateHeight: false,
			spaceBetween: 15,
			navigation: {
				nextEl: '.reviews-slider-wrapper .arrow.next',
				prevEl: '.reviews-slider-wrapper .arrow.prev',
			},
			pagination: {
				el: '.reviews-slider .pagination',
				clickable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 20
				},
				1201: {
					slidesPerView: 3,
					spaceBetween: 20
				}
			},

			// fix the loop for when you have lazyloaded images inside it
			// https://github.com/verlok/vanilla-lazyload/blob/master/demos/swiper.html
			on: {
				afterInit: (swiper) => {
					new LazyLoad({
						container: swiper.el,
						cancel_on_exit: false
					});
				}
			}
		});

		setTimeout(function () {
			reviews_slider.update()
		}, 10);

	}

	if (document.querySelector('.blog-slider')) {
		const blog_slider = new Swiper('.blog-slider', {
			slidesPerView: 1,
			loop: false,
			simulateTouch: true,
			allowTouchMove: true,
			autoHeight: true,
			calculateHeight: true,
			spaceBetween: 15,
			pagination: {
				el: '.blog-slider .pagination',
				clickable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 25,
				},
				993: {
					slidesPerView: 3,
					spaceBetween: 30,
				}
			}
		});

		setTimeout(function () {
			blog_slider.update()
		}, 10);
	}

	if (document.querySelector('.product-slider')) {
		const product_slider = new Swiper('.product-slider', {
			slidesPerView: 1,
			loop: false,
			simulateTouch: true,
			allowTouchMove: true,
			autoHeight: true,
			calculateHeight: true,
			spaceBetween: 0,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			pagination: {
				el: '.product-slider .product-nav',
				clickable: true,
			},
			breakpoints: {
				993: {
					autoHeight: false,
					calculateHeight: false
				}
			}
		});

		setTimeout(function () {
			product_slider.update()
		}, 300);
	}

}

function acceptCookies() {
	console.log("Accepted");
	setCookie("cookies", "true", 999);
}

// init cookies popup
function initCookiesPopup() {
	console.log("COOKIES POPUP");
	if (!checkCookie("cookies")) {
		setTimeout(function () {
			console.log('test')
			$('#cookies-popup').fadeIn();
		}, 3000);
	}
}

// play videos when in view
function playVideoInView() {

	let allVideoDivs = gsap.utils.toArray('.play-pause');

	allVideoDivs.forEach((videoDiv) => {

		let videoElem = videoDiv.querySelector('video')

		ScrollTrigger.create({
			trigger: videoElem,
			start: '0% 120%',
			end: '100% -20%',
			onEnter: () => videoElem.play(),
			onEnterBack: () => videoElem.play(),
			onLeave: () => videoElem.pause(),
			onLeaveBack: () => videoElem.pause(),
		});

	});
}

function setCookie(cname, cvalue, exdays) {
	const d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	let expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
	let name = cname + "=";
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

function checkCookie(name) {
	let username = getCookie(name);
	console.log("Username: " + username);
	if (username != "") {
		return true;
	} else {
		return false;
	}
}

// opening animation
function openingAnimation() {

	let username = getCookie('loader');

	const opening = gsap.timeline();

	opening.set('#opening-animation', {
		autoAlpha: 1,
		pointerEvents: 'all'
	})

	opening.call(function () {
		initScript()
		initCookiesPopup()

		// detect if the user is on safari, and if it is
		// create a play button below the opening logo to
		// fake an autoplay on the videos
		// https://stackoverflow.com/questions/6849086/jquery-target-only-safari
		if (
			navigator.userAgent.indexOf('Safari') != -1 &&
			navigator.userAgent.indexOf('Chrome') == -1 &&
			navigator.userAgent.indexOf('CriOS/') == -1
		) {

			opening.pause()

			$('#opening-animation').css({
				'visibility': 'visible',
				'opacity': '1',
				'pointer-events': 'all',
				'background': '#141517'
			});

			$('#opening-animation button').css({
				'transform': 'none',
				'visibility': 'visible',
				'opacity': '1'
			});

			$('#opening-animation button').click(function () {
				opening.play()
				$('#banner video').get(0).play();
			})

		} else {
			$('#banner video').get(0).play();
		}
	})

	opening.to('#opening-animation', {
		autoAlpha: 0,
		pointerEvents: 'none',
		duration: 1.75,
		delay: .5,
		ease: Power2.easeOut
	})

	setCookie("loader", "true", 365);
}

// scroll to the top of the page
function scrollTop() {
	window.scrollTo(0, 0);
}

// delay function
function delay(n) {
	n = n || 2000;
	return new Promise((done) => {
		setTimeout(() => {
			done();
		}, n);
	});
}

// fire all scripts
function initScript() {
	initClickAndKeyFunctions();
	validateForms();
	scrollTriggerAnimations();
	initLazyLoad();
	initFancybox();
	staggerChildren();
	initSliders();
	playVideoInView();
}


// doc ready functions
$(document).ready(function () {

	// home functions (openingAnimation has initScript inside it)
	if ($('#main-content').hasClass('home')) {
		openingAnimation()
		$('#top-menu').addClass('home');

		// dashboard functions
	} else if ($('#main-content').hasClass('dashboard')) {
		$('.dashboard-menu a').removeClass('active')
		initDashboardMenu()
		initScript()

		// all other pages
	} else {
		initScript()
	}

	var currentPath = window.location.pathname;
	if (currentPath === "/cart") {
	   window.location.href = '/products?open-cart=true';
	}
 
	var queryString = window.location.search;  
	if (queryString.indexOf("open-cart=true") !== -1) {
		console.log('querystring', queryString);
		openCart();
	}
})